module.exports = __webpack_public_path__ + "img/ep4-4.60a60afa.png";